import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ovrview',
  templateUrl: './ovrview.component.html',
  styleUrls: ['./ovrview.component.scss']
})
export class OvrviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
